/**
 * hooks.ts — typed React-Redux hooks for @hostesa/state.
 *
 * useAppDispatch and useAppSelector are typed against the store's RootState
 * and AppDispatch so callers get full inference without repeating generics.
 *
 * Usage:
 *   import { useAppDispatch, useAppSelector } from '@hostesa/state';
 *   const dispatch = useAppDispatch();
 *   const theme = useAppSelector(selectTheme);
 */

import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './store';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
